<template>
  <div
    class="pages-container"
    :style="{
      ...this.$store.state.style,
      backgroundImage: `url(${main_bgImg})`,
    }"
  >
    <div class="header-container">
      <!-- <img src="../../assets/images/cropwise-logo.png" /> -->
      <img
        v-bind:src="
          require('../../assets/images/' +
            this.$store.state.style['--main_logo'])
        "
      />

      <div class="float-right">
        <dashboard-welcome :user="user"></dashboard-welcome>
        <!--<dashboard-search></dashboard-search>
        <dashboar-preview></dashboar-preview>-->
      </div>
      <div class="clearfix"></div>
    </div>
    <nav>
      <img class="nav-icon" src="../../assets/images/leaf-icon.png" />
    </nav>
    <view-mode-board
      v-if="user && userMenuesLoaded"
      :user="user"
    ></view-mode-board>
    <edit-mode-board v-if="false"></edit-mode-board>
    <Authorization
      v-if="this.$store.state.unAuthorizedUser && user"
    ></Authorization>
  </div>
</template>

<script>
import DashboardWelcome from "./DashboardWelcome.vue";
import ViewModeBoard from "./../viewMode/ViewModeBoard.vue";
import EditModeBoard from "./../editMode/EditModeBoard.vue";
import Authorization from "./../authorization/Authorization";
import portalAPI from "../../services/portalService";
import StorageService from "../../services/storageService";

let pAPI = new portalAPI();

let storageService = new StorageService();
export default {
  name: "MainDashboard",
  components: {
    DashboardWelcome,
    ViewModeBoard,
    EditModeBoard,
    Authorization,
  },
  data() {
    return {
      userMenuesLoaded: false,
    };
  },
  props: ["user"],
  methods: {},
  computed: {
    logoutNotification: function () {
      return this.$store.getters.logoutInitiated;
    },
    main_bgImg: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.$store.state.style["--main_background_image"]}`;
    },
  },
  watch: {
    logoutNotification(newVal) {
      let that = this;
      if (newVal) {
        that.$store.dispatch("trackLogoutAction").then(() => {
          let authMode = storageService.get("auth_mode");
          storageService.clearAll();
          that.$AuthService.logout();
          if (authMode != "cw") {
            that.$router.go("/");
          }
        });
      }
    },
  },
  created: function () {
    let that = this;

    pAPI.getUserMenus().then((res) => {
      that.userMenuesLoaded = true;
      that.$store.commit("updateUserNodes", {
        userNodes: res ? res.data : [],
      });
    });

    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight * 0.01}px`
    );
    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pages-container {
  font-family: var(--font_family);
  color: #fff;
  /* background: url(../../assets/images/bg.svg) no-repeat #00809e;
  background-size: cover;
  height: calc(100vh); fallback if css var is not supported */
  height: var(--pages_height);

  overflow-x: hidden;
  background-size: cover;
  border-bottom: var(--body_border);
}
.header-container {
  background: var(--header_color);
  height: 75px;
  padding: var(--header_padding);
  color: var(--main_color);
  border-top: var(--header_border);
  border-bottom: var(--header_border);
  box-shadow: var(--header_boxshadow);
}
.header-container img {
  height: var(--main_logo_height);
  display: var(--logo_display);
  margin: var(--main_logo_margin);
}
nav {
  display: var(--nav_display);
  background: var(--nav_bg_color);
  position: fixed;
  width: 80px;
  height: calc(100vh); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100));
  top: 0;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
